module.exports = __webpack_public_path__ + "img/category.2fa491ab.png";